module.exports = __webpack_public_path__ + "static/media/tick_check_mark.f19b70cc.svg";